/* ===== AROMAZUR v15 - liens reels + comportement inchange ===== */
(function(){
  function onClick(e){
    var a=e.target.closest?e.target.closest('a[data-az-scroll]'):null;
    if(!a) return;
    if(e.metaKey||e.ctrlKey||e.shiftKey||e.button===1) return; /* ouvrir dans un onglet : comportement natif */
    var sel=a.getAttribute('data-az-scroll');
    var el=document.querySelector(sel);
    if(!el) return; /* section absente (page interieure) : on laisse le lien agir */
    e.preventDefault();
    el.scrollIntoView({behavior:'smooth'});
    if(window.closeMobileMenu) try{closeMobileMenu();}catch(_){}
  }
  document.addEventListener('click',onClick);
})();
